import { useEffect, useState } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import Sidebar from './Sidebar'
import TopBar from './TopBar'

export default function MainLayout() {
  const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);
  const { pathname } = useLocation();

  // 路由切换时滚动到顶部。requirement detail overlay 用 replaceState 改 URL,
  // 不会改变 React Router 的 pathname,因此关闭 overlay 返回 program/home 时
  // 底层滚动进度会自然保留,不在此处重置。
  useEffect(() => {
    document.getElementById('main-scroll-area')?.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className="h-screen overflow-hidden bg-white">
      <TopBar onMenuToggle={() => setIsMobileNavOpen(o => !o)} />
      <Sidebar isOpen={isMobileNavOpen} onClose={() => setIsMobileNavOpen(false)} />
      {isMobileNavOpen && (
        <div
          className="fixed inset-0 z-[999] bg-black/30 xl:hidden"
          onClick={() => setIsMobileNavOpen(false)}
        />
      )}
      <div id="main-scroll-area" className="mt-16 xl:ml-[245px] h-[calc(100vh-4rem)] overflow-y-auto">
        <main>
          <Outlet />
        </main>
      </div>
    </div>
  )
}
